import { ensureActive2yo7199srjlgl as ensureActive } from '../../Job.mjs';
import { checkContext31s2o65fax7nj as checkContext } from './SafeCollector.common.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { FlowCollector26clgpmzihvke as FlowCollector } from '../FlowCollector.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function SafeCollector$collectContextSize$lambda(count, _unused_var__etf5q3) {
  return count + 1 | 0;
}
var SafeCollectorClass;
function SafeCollector() {
  if (SafeCollectorClass === VOID) {
    class $ {
      constructor(collector, collectContext) {
        this.t1d_1 = collector;
        this.u1d_1 = collectContext;
        var tmp = this;
        tmp.v1d_1 = this.u1d_1.qm(0, SafeCollector$collectContextSize$lambda);
        this.w1d_1 = null;
      }
      *r1d(value, $completion) {
        // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
        // Inline function 'kotlin.js.getCoroutineContext' call
        var currentContext = $completion.mc();
        ensureActive(currentContext);
        if (!(this.w1d_1 === currentContext)) {
          checkContext(this, currentContext);
          this.w1d_1 = currentContext;
        }
        yield* this.t1d_1.r1d(value, $completion);
        return Unit_instance;
      }
      wc() {
      }
    }
    initMetadataForClass($, 'SafeCollector', VOID, VOID, [FlowCollector()], [1]);
    SafeCollectorClass = $;
  }
  return SafeCollectorClass;
}
//region block: exports
export {
  SafeCollector as SafeCollector3ss0wp8n80f6m,
};
//endregion

//# sourceMappingURL=SafeCollector.mjs.map
